import { render, staticRenderFns } from "./AddressStep.vue?vue&type=template&id=81b320f6&scoped=true&"
import script from "./AddressStep.vue?vue&type=script&lang=js&"
export * from "./AddressStep.vue?vue&type=script&lang=js&"
import style0 from "./AddressStep.vue?vue&type=style&index=0&id=81b320f6&prod&scoped=true&lang=css&"
import style1 from "./AddressStep.vue?vue&type=style&index=1&id=81b320f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b320f6",
  null
  
)

export default component.exports